import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { action, computed } from 'mobx';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { splitApp } from '../../../utils/appSplit';
import { ISplitAppInputs } from '../../../models/app/ISplitAppInputs';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
		if (!(window as any)['__ksysSplitAppFunctions__']) {
			(window as any)['__ksysSplitAppFunctions__'] = {};
		}
		if (manifest.packageName) {
			(window as any)['__ksysSplitAppFunctions__'][manifest.packageName] = splitApp;
		}
	}

	@computed
	get hasData(): boolean {
		// TODO: Each Application should put custom show logic here: "return this.storeContext[component store].hasData;"
		return true;
	}

	@action
	contextsDidUpdateAfter = async () => {
		// TODO: Each Application should put custom logic here to handle changes to the data context
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get cardProps(): ICardProps | undefined {
		const cardProps = this.appComponentConfiguration && this.appComponentConfiguration.cardProps;
		const response: ICardProps | undefined = this.mergeQueriesAndProps(cardProps);
		if (this.splitAppOptions && response) {
			const { hideCardHeader } = this.splitAppOptions;
			if (hideCardHeader) {
				response.title = undefined;
				response.subtitle = undefined;
			}
		}
		return response;
	}

	async customInitializeAfter() {
		this.storeContext.disclaimersStore.initialize();
	}

	@computed
	get splitAppOptions() {
		const inputs = (this.appParamsHelper.inputs || {}) as ISplitAppInputs;
		const limit = parseInt(inputs.limit || '0', 10);
		const start = parseInt(inputs.start || '0', 10);
		return {
			limit,
			start,
			inputs,
			hideCardHeader: inputs.hasCardHeader === 'false',
			hideRows: start === -1 || limit === 0,
			mustLimitRows: start || limit,
		};
	}

}